// Define dataLayer and the gtag function.
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}

const analyticsPublish = (event, payload) => {
  try {
    Shopify.analytics.publish(event, payload);
  } catch (e) {
    console.error('analyticsPublish failed:', event, e);
  }
};

const generateEventId = () =>
  window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

// Stamps a single event_id onto both the GTM dataLayer push and the Shopify analytics publish
// for a given event firing, so downstream consumers (e.g. FB Pixel + Conversions API) can dedupe.
const trackEvent = (eventName, payload = {}) => {
  const event_id = generateEventId();
  window.dataLayer.push({ event: eventName, event_id, ...payload });
  analyticsPublish(`decked:${eventName}`, { event_id, ...payload });
};

document.addEventListener('dealerLocator:results', e => {
  const payload = { dealer_locator: { ...e.detail } };
  trackEvent('dealer_locator_results', payload);
});

document.addEventListener('dealerLocator:search', e => {
  console.log('dealerLocator:search', e.detail);
  const payload = {
    customerId: window.__VPV.customerId,
    dealer_locator: { ...e.detail },
  };
  trackEvent('dealer_locator_search', payload);
});

document.addEventListener('dealerLocator:filter', e => {
  const payload = {
    dealer_locator: { ...e.detail },
  };
  trackEvent('dealer_locator_filter', payload);
});

document.addEventListener('dealerLocator:contact', e => {
  const payload = {
    dealer_locator: { contact: { ...e.detail } },
  };
  trackEvent('dealer_locator_contact', payload);
});

document.addEventListener('carousel:view_item', e => {
  const payload = { carousel: { ...e.detail } };
  trackEvent('carousel_view_item', payload);
});

document.addEventListener('carousel:scroll_to', e => {
  const payload = { carousel: { ...e.detail } };
  trackEvent('carousel_scroll_to', payload);
});

document.addEventListener('carousel:slide_to', e => {
  const payload = { carousel: { ...e.detail } };
  trackEvent('carousel_slide_to', payload);
});

document.addEventListener('search:predictive', e => {
  const payload = { search_term: e.detail };
  trackEvent('search_predictive', payload);
});

window.addEventListener('vehicleSubmitted', e => {
  const { make, model, year } = e.detail;
  const payload = { vehicle_make: make, vehicle_model: model, vehicle_year: year };
  trackEvent('vehicle_picker_submit', payload);
});

window.addEventListener('variantSelected', e => {
  const { detail } = e;
  if (detail) {
    const currency = Shopify?.currency?.active;
    const productType = detail.product.productType === 'Decked' ? 'Drawers' : detail.product.productType;
    const payload = {
      ecommerce: {
        currency,
        items: [
          {
            item_category: productType,
            item_type: productType,
            item_name: detail.product?.title,
            item_id: detail.id,
            price: detail.priceV2?.amount,
            item_variant: detail.title,
            item_sku: detail.sku,
            quantity: 1,
            currency,
          },
        ],
      },
    };
    trackEvent('select_item', payload);
  }
});

document.addEventListener("variant:add", e => {
  const { items } = e.detail;
  trackCustomAddToCartEvent(items);
});
document.addEventListener("customizer:variant:add", e => {
  const { item } = e.detail;
  trackCustomAddToCartEvent([item]);
});


//Dialog events
document.addEventListener("dialog:after-hide", e => {
  const payload = {
    dialog: { id: e.target.id, element_type: e.target.tagName?.toLowerCase() }
  };
  trackEvent("dialog_close", payload);
});
document.addEventListener("dialog:after-show", e => {
  const payload = {
    dialog: { id: e.target.id, element_type: e.target.tagName?.toLowerCase() }
  };
  trackEvent("dialog_open", payload);
});
document.addEventListener("dialog-tray:show", e => {
  const payload = {
    dialog: { id: e.target.id, element_type: "tray" }
  };
  trackEvent("dialog_tray_open", payload);
});
document.addEventListener("dialog-tray:hide", e => {
  const payload = {
    dialog: { id: e.target.id, element_type: "tray" }
  };
  trackEvent("dialog_tray_close", payload);
});

const trackCustomAddToCartEvent = (items) => {
  if (items.length > 0) {
    const currency = Shopify?.currency?.active;
    const vehicle = VehicleData?.getSelectedVehicle();

    const payload = {
      ecommerce: {
        currency,
        items: items.map(item => {
          return {
            item_category: item.product_type,
            item_type: item.product_type,
            item_name: item.product_title,
            item_photo: item.image,
            item_id: item.variant_id,
            price: (item.price / 100).toFixed(2),
            item_brand: item.vendor,
            item_variant: item.variant_title,
            item_sku: item.sku,
            quantity: item.quantity || 1,
            source: item.source,
            vehicle_make: vehicle?.make,
            vehicle_model: vehicle?.model,
            vehicle_year: vehicle?.year,
            vehicle_body_style: vehicle?.body_style,
            vehicle_bed_length: vehicle?.bed_length
          }
        })
      },
    };
    trackEvent("custom_add_to_cart", payload);
  }
}


const cartDrawerEl = document.getElementById('cart-drawer');
if(cartDrawerEl){
    cartDrawerEl.addEventListener('toggle', e => {
        const eventName = e.target.open ? 'mini_cart_open' : 'mini_cart_close';
        trackEvent(eventName);
    });
}

window.Shopify.loadFeatures(
  [
    {
      name: 'consent-tracking-api',
      version: '0.1',
    },
  ],
  (error) => {
    if (error) {
      console.error('Failed to load Shopify Customer Privacy API:', error);
      return;
    }

    const cp = window.Shopify.customerPrivacy;
    const shouldShow = cp.shouldShowBanner()
    const consent = cp.currentVisitorConsent()
    const hasDecided = Object.values(consent).some(v => v !== '');

    if (!shouldShow && !hasDecided) {
        const defaultConsent = {
          ad_storage: 'granted',
          analytics_storage: 'granted',
          ad_user_data: 'granted',
          ad_personalization: 'granted',
        }
        gtag('consent', 'default', defaultConsent);
        console.log('[Default Consent Set, no banner]', consent, defaultConsent);
        window.loadHeapAnalytics?.();
    }
    else {
        if (hasDecided) {
            gtag('consent', 'default', GTMConsentFromShopifyConsent(consent))
            console.log('[Consent Sync]', consent, GTMConsentFromShopifyConsent(consent));
            if (GTMConsentFromShopifyConsent(consent).analytics_storage === 'granted') {
                window.loadHeapAnalytics?.();
            } else {
                skipHeapAnalytics('analytics denied');
            }
        } else {
            const defaultConsent = {
              ad_storage: 'denied',
              analytics_storage: 'denied',
              ad_user_data: 'denied',
              ad_personalization: 'denied',
            }
            gtag('consent', 'default', defaultConsent)
            console.log('[Default Consent Set, showing banner]', consent, defaultConsent);
            skipHeapAnalytics('awaiting consent');
        }
    }
  }
);


document.addEventListener("visitorConsentCollected", (event) => {
    if (!event.detail) return;
    gtag('consent', 'update', GTMConsentFromShopifyConsent(event.detail, "event"));
    trackEvent('consent_collected', event.detail);
    console.log("[Consent Sync]", event.detail, GTMConsentFromShopifyConsent(event.detail, "event"))
    if (event.detail.analyticsAllowed) {
        console.log('[Heap] consent granted via banner, loading');
        window.loadHeapAnalytics?.();
    }
});

// Lets anything waiting on heapReady (GrowthBook) stop waiting when Heap isn't going to load
function skipHeapAnalytics(reason) {
    console.log('[Heap] skipped:', reason);
    window.heapSkipped = true;
    window.dispatchEvent(new CustomEvent('heapSkipped'));
}

//
// @param type: "fetch" | "event"
// The shape is different between Shopify.customerPrivacy.currentVisitorConsent() and the "visitorConsentCollected" event
//
// "fetch" values are "yes" | "no" | "", "event" values are true | false. "" (not yet answered) defaults to granted.
function toGrantStatus(value, type) {
    if (type === "fetch") return value === "no" ? "denied" : "granted";
    return value === false ? "denied" : "granted";
}

function GTMConsentFromShopifyConsent(consent, type = "fetch") {
    // grab property based on the correct key
    const ad_storage = type === "fetch" ? consent?.marketing : consent?.marketingAllowed;
    const analytics_storage = type === "fetch" ? consent?.analytics : consent?.analyticsAllowed;
    const ad_user_data = type === 'fetch' ? consent?.marketing : consent?.marketingAllowed;
    const ad_personalization = type === "fetch" ? consent?.marketing : consent?.marketingAllowed;
    const functionality_storage = type === 'fetch' ? consent?.preferences : consent?.preferencesAllowed;
    const personalization_storage = type === 'fetch' ? consent?.preferences : consent?.preferencesAllowed;
    // sale_of_data opt out overrides marketing for the ad related fields
    const sale_of_data = type === 'fetch' ? consent?.sale_of_data : consent?.saleOfDataAllowed;
    const saleOfDataDenied = toGrantStatus(sale_of_data, type) === 'denied';
    const adStatus = (value) => saleOfDataDenied ? 'denied' : toGrantStatus(value, type);
    return {
      ad_storage: adStatus(ad_storage),
      analytics_storage: toGrantStatus(analytics_storage, type),
      ad_user_data: adStatus(ad_user_data),
      ad_personalization: adStatus(ad_personalization),
      functionality_storage: toGrantStatus(functionality_storage, type),
      personalization_storage: toGrantStatus(personalization_storage, type),
    };
}
